import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunnerOptionalParameter,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import {
    getCurrentWebsite,
    GetCurrentWebsiteApiParameter,
    Website,
} from "@insite/client-framework/Services/WebsiteService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Context/Handlers/LoadCurrentWebsite";

type HandlerType = ApiHandlerDiscreteParameter<{}, GetCurrentWebsiteApiParameter, Website>;

export const PopulateApiParameterExtended: HandlerType = props => {
    props.apiParameter = {
        expand: ["languages", "currencies"],
    };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtended);
